var VisaPaymentProvider = (function (CheckoutApiModel, GlobalSettings, CheckoutSettings) {

	var formButtonsContainer = '#bt-checkout-form-buttons';
	var checkoutButtonsContainer = '#bt-checkout-buttons-current';
	var allButtonsContainer = '#bt-checkout-buttons-all';

	var addMethodButton,
		currentMethodButton,
		newMethodButton;

	var displayButtons = false;
	var displayButtonsNew = true;

    var VisaPaymentProvider = CheckoutApiModel.extend({

        type: CheckoutSettings.PaymentType.VisaCheckoutCS,
        paymentOption: CheckoutSettings.PaymentOption.VisaCheckoutCyberSource,
        _supportedTypes: [CheckoutSettings.PaymentType.VisaCheckoutCS],
        _supportedOrderTypes: [CheckoutSettings.OrderPaymentType.VisaCheckoutCS],

        initialize: function (set, opt) {

            _.bindAll(this, '_addButtons', '_summaryChanged', '_prepayment', '_complete');

            this._order = opt.order;
            this._current = opt.current;
            this._service = opt.service;
            this._visaSettings = CheckoutSettings.getBasketSettings().Visa;
            this._handleValidtion = opt.handleValidtion;
            this._bt = opt.bt;

            if (this._visaSettings.Enabled) {
                this._addButtons();
                this._initVisa();
                this._order.get('Summary').on('change', this._summaryChanged);
                this._order.on('change', _.bind(function (order) {
                    this._toggleButtonsOnOrder(order);
                }, this));

                this._current.on('change', _.bind(function (model) {
                    this._toggleButtonsOnPaymentMethod(model);
				}, this));

				// NOTE: if smth will go wrong after display change (fail with DOM buttons, wrong reinits of visa checkout, etc)
				DisplayRouter.GlobalDisplayHook.on(DisplayRouter.GlobalDisplayHook.eventTypes.changeDisplay, _.bind(function (place) {
					this._place = place;
                    this._summaryChanged(opt.order.get('Summary'));
                    this._toggleButtonsOnPaymentMethod(this._current);
                    this._toggleButtonsOnOrder(this._order);
				}, this));
				this.visaCheckout.$ready.then(_.bind(function () {
					this._summaryChanged(opt.order.get('Summary'));
                    this._toggleButtonsOnPaymentMethod(this._current);
                    this._toggleButtonsOnOrder(this._order);
                }, this));
			}
        },

        _toggleButtonsOnOrder: function (order) {
            displayButtonsNew = _.some(this._order.attributes.AvailablePaymentOptions,
                function (po) {
                    return po.Name.toLowerCase() === CheckoutSettings.PaymentOption.VisaCheckoutCyberSource.toLowerCase();
                });
            newMethodButton.toggle(displayButtonsNew);
            //addMethodButton.toggle(displayButtonsNew);
        },

        _toggleButtonsOnPaymentMethod: function (model) {
            displayButtons = model.get('PaymentType') === CheckoutSettings.PaymentType.VisaCheckoutCS;
            currentMethodButton.toggle(displayButtons);
        },

		_initVisa: function () {
			this.visaCheckout = new VisaCheckout({
				apikey: this._visaSettings.APIKey,
				enabled: this._visaSettings.Enabled,
				visaApiDomain: this._visaSettings.APIUrl,
				success: this._complete,
				error: function(data) { console.log(data); },
				cancel: function(data) { console.log(data); },
				totals: this._order.get('Summary').toJSON(),
				currencyCode: GlobalSettings.Currency,
				prePayment: this._prepayment,
				resizeButton: true
			});
		},

		_summaryChanged: function(model) {
			this._addButtons();
			if (!model.toJSON().TotalWithSelect) {
				return;
			}
			this.visaCheckout.updateTotals(model.toJSON());
		},

		_addButton: function (data, appendToEl, currentButton, tmpl) {
			var button = visa_checkout_button.getbutton(data, this._prepayment, this._visaSettings.APIUrl, tmpl);
			if (currentButton) {
				currentButton.replaceWith(button);
			} else {
				button.appendTo(appendToEl);
			}
			return button;
		},

		_addButtons: function() {
			//addMethodButton = this._addButton({ id: 'checkoutVisa', role: 'checkoutVisa', testClass: 'test-visa-button' }, $(formButtonsContainer), addMethodButton);
			currentMethodButton = this._addButton({ id: 'bt-checkout-buttons-current-visa', role: 'bt-checkout-buttons-current-visa', testClass: 'test-visa-button' }, $(checkoutButtonsContainer), currentMethodButton, 'bt-checkout-button-braintree-vco');
			newMethodButton = this._addButton({ id: 'bt-checkout-buttons-visa', role: 'bt-checkout-buttons-visa', testClass: 'test-visa-button' }, $(allButtonsContainer), newMethodButton);
			currentMethodButton.toggle(displayButtons);
			newMethodButton.toggle(displayButtonsNew);
			//addMethodButton.toggle(displayButtonsNew);
		},

		_prepayment: function () {
			var def = new $.Deferred();
			var value = this._service.checkValid();
			if (value.result) {
				// NOTE: if current payment method is VCBT then do not show popup and just do create payment transaction.
				// NOTE: only NOT for form view!
				if (this._current.get('PaymentType') === CheckoutSettings.PaymentType.VisaCheckoutCS
				) {
					this._complete({
						token: this._current.get('Token')
					});
				} else {
					def.resolve();
				}
			} else {
				(new this._handleValidtion()).handle(value.reason,
					{
						backTo: 'checkout'
					});
			}
			return def.promise();
		},

        _complete: function (data) {
            var deviceData = this._bt.kount.getDeviceData();
            this._service._paymentStrategy.beforeProcess(data)
                .then(_.bind(function(data) {
                    var transactionData = _.extend({ callid: data.token || '' }, data, {
                        paymentType: this.type,
                        selectedPaymentOption: this.paymentOption,
                        paymentNonce: data.nonce || '',
                        paymentToken: data.token || '',
                        deviceData: deviceData
                    });
                    return transactionData;
                }, this))
                .then(_.bind(function (transactionData) {
                    return this._createPaymentTransaction(transactionData, { wait: true, preventDoubleRequests: true });
                }, this))
                .then(_.bind(this._service._paymentStrategy.afterComplete, this._service._paymentStrategy));

		}
	});

	return VisaPaymentProvider;
})(CheckoutApiModel, GlobalSettings, CheckoutSettings);
